/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import L from "../Lang";
import Switch from "../Switch";
import UploadImage from "../UploadImage";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class DataManagerEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {}
        };
    }

    async componentDidMount() {
        await this.loadModel();
        await this.load();
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    loadModel = async () => {
        try {
            const j = await qreq.getAsync('/api/data/model/info/' + this.props.params.model);
            if (j.item) {
                this.setState({ model: j.item });
                const info = { ...this.state.info };
                j.item.cols.forEach(col => {
                    if (col.dataType === 'Boolean')
                        info[col.name] = false;
                    else if (col.dataType === 'String')
                        info[col.name] = '';
                });
                this.setState({ info: info });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    load = async () => {
        if (this.props.params.id) {
            try {
                const j = await qreq.getAsync('/api/data/model/data/item/' + this.props.params.model + '/' + this.props.params.id);
                if (j.item) {
                    this.setState({ info: j.item });
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        }
    }

    submit = async (e) => {
        e?.preventDefault();
        const info = { ...this.state.info };
        try {
            const j = await qreq.postAsync('/api/data/model/data/save/' + this.props.params.model, info);
            if (j.errorCode === 0) {
                this.success('Saved!');
                this.goBack();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    setVal = (name, val) => {
        const info = { ...this.state.info };
        info[name] = val;
        this.setState({ info: info });
    }

    toggleUploadImage = (c) => {
        const cols = [...this.state.model.cols];
        const col = cols.find(x => x.name === c.name);
        if (!col) return;
        col.__changeImage = !col.__changeImage;
        this.setState({
            model: { ...this.state.model, cols: cols }
        });
    }

    toggleSwitch = (e, c) => {
        const info = { ...this.state.info };
        info[c.name] = e.target.checked;
        this.setState({ info: info });
    }

    render() {
        return <div className="container-fluid">
            <h1>{this.state.model?.name}: {this.props.new ? <L>New</L> : <L>Edit</L>}</h1>
            <form onSubmit={this.submit}>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg">
                        <Icon icon="faSave" /> <L>Save</L>
                    </button>
                </AppActions>
                <Card>
                    {this.state.model?.cols?.map((c, cdx) => <div key={cdx}>
                        {c.isImage ? (this.state.info[c.name] && !c.__changeImage ? <div>
                            <label className="form-label d-block">{c.sortName}</label>
                            <img src={Globals.getStorageURL(this.state.info[c.name], true)} alt="" className="d-block img-fluid mb-3" />
                            <button type="button" className="btn btn-secondary" onClick={() => this.toggleUploadImage(c)}>
                                <L>Change Image</L>
                            </button>
                        </div>
                            : <UploadImage onChange={(v) => this.setVal(c.name, v.fileIdent)} />)
                            : c.name === 'color' ? <FormInput model={this.state.info} name={c.name} label={c.sortName} type="color" />
                                : c.typeInfo === 'TEXT' ? <FormInput model={this.state.info} name={c.name} label={c.sortName} type="textarea" />
                                    : c.dataType === 'Boolean' ? <Switch checked={this.state.info[c.name]} onChange={e => this.toggleSwitch(e, c)} label={c.sortName} />
                                        : <FormInput model={this.state.info} name={c.name} label={c.sortName} />}
                    </div>)}
                </Card>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(DataManagerEdit);